import "./LoggerStore";
import axios from "axios";
import serverurl from "../scripts/ServerUrl";
import { writable, get } from "svelte/store";
const refineRoute = (route) => {
    let retval = route;
    while (retval.includes("//")) {
        retval = retval.replace("//", "/");
    }
    return retval;
};
export class _JamUser {
    constructor() {
        //fields
        this._url = serverurl("user/");
        this._uid = writable("");
        this._loggedIn = writable(false);
    }
    url(endRoute) {
        return this._url + endRoute;
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = _JamUser.Empty();
        }
        return this.instance;
    }
    get getId() {
        return get(this._uid);
    }
    get getIdReadable() {
        return this._uid;
    }
    setId(id) {
        // this._uid.update((_) => id);
        this._uid.set(id);
        return this;
    }
    setEmpty() {
        this.setId("");
        return this;
    }
    static Empty() {
        return new _JamUser();
    }
    get isEmpty() {
        return this.getId.length === 0;
    }
    logout() {
        axios.defaults.headers.common["Authorization"] = undefined;
        this.setEmpty();
        this._loggedIn.set(false);
    }
    isLoggedIn() {
        return get(this._loggedIn);
    }
    isLoggedInReadable() {
        return this._loggedIn;
    }
    async signup(id, pw, onError, onFinish) {
        if (!this.isEmpty) {
            return this;
        }
        const signup = await axios
            .post(this.url("signup"), {
            user: id,
            pass: pw,
        })
            .then((_) => _)
            .catch((err) => onError === null || onError === void 0 ? void 0 : onError(err));
        console.log(signup);
        return signup;
    }
    async login(id, pw, onError, onFinish) {
        if (!this.isEmpty) {
            return this;
        }
        let result;
        await axios
            .post(this.url("login"), {
            user: id,
            pass: pw,
        })
            .then((res) => {
            // console.log("Log in response : ", res);
            // const { accessToken } = res.data;
            // API 요청하는 콜마다 헤더에 accessToken 담아 보내도록 설정
            axios.defaults.headers.common["Authorization"] = `Bearer ${res.data["accessToken"]}`;
            // console.log("TOken : ", res.data["accessToken"]);
            result = { accessToken: res.data["accessToken"] };
        })
            .catch((err) => onError === null || onError === void 0 ? void 0 : onError(err));
        console.log("Is login result : ", result);
        if (result) {
            // debugger;
            this.setId(id);
            this._loggedIn.set(true);
            onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        }
        return this;
    }
}
export class _JamBread {
    constructor() {
        //fields
        this._url = serverurl("bread/");
        this._bid = writable("");
    }
    url(endRoute) {
        return this._url + endRoute;
    }
    isLoggedIn() {
        return _JamUser.getInstance().isLoggedIn();
    }
    isLoggedInReadable() {
        return _JamUser.getInstance().isLoggedInReadable();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = _JamBread.Empty();
        }
        return this.instance;
    }
    get getId() {
        return get(this._bid);
    }
    get getIdReadable() {
        return this._bid;
    }
    setId(id) {
        this._bid.set(id);
        return this;
    }
    setEmpty() {
        this.setId("");
        return this;
    }
    static Empty() {
        return new _JamBread();
    }
    get isEmpty() {
        return this.getId.length === 0 || !this.isLoggedIn;
    }
    async list() {
        if (!this.isLoggedIn) {
            return undefined;
        }
        const res = await axios.get(this.url("list"));
        console.log("Res ; ", res);
        if (res.status) {
            console.log("REtruning ", res.data.content);
            return res.data.content;
        }
        return undefined;
    }
    async bake(breadId) {
        if (!this.isLoggedIn) {
            return undefined;
        }
        const res = await axios.post(this.url("bake"), {
            bid: breadId,
        });
        console.log("Res ; ", res);
        if (res.status) {
            console.log("REtruning ", res.data.content);
            return res.data.content;
        }
        return undefined;
    }
    async load(breadId) {
        if (!this.isLoggedIn) {
            return undefined;
        }
        const res = await axios
            .get(this.url(`data/${breadId}`))
            .then((_) => _)
            .catch((err) => console.error(err));
        console.log("Res ; ", res);
        if (res) {
            console.log("REtruning ", res.data);
            return res.data;
        }
        return undefined;
    }
    async save(breadId, files, proc) {
        if (!this.isLoggedIn) {
            return undefined;
        }
        const res = await axios
            .post(this.url(`data/${breadId}`), { files: files, proc: proc })
            .then((_) => _)
            .catch((err) => console.error(err));
        console.log("Res ; ", res);
        if (res) {
            console.log("REtruning ", res.data);
            return res.data;
        }
        return undefined;
    }
}
// export const Router = _Router.getInstance();
export const JamUser = _JamUser.getInstance();
export const JamBread = _JamBread.getInstance();
